import { useCallback, useEffect, useState } from "react";

import { useGlobalPayments } from "Payments/GlobalPaymentsContext";
import API from "Payments/ManagePaymentMethods/API";
import { useManagePaymentMethods } from "Payments/ManagePaymentMethods/ManagePaymentMethodsContext";
import {
  useFetching,
  usePaymentMethodProviders,
} from "Payments/globalPaymentsStateHooks";

export default function usePaymentMethodData(userID) {
  const { state } = useGlobalPayments();
  const { dispatch } = useManagePaymentMethods();
  const { setPaymentMethodProviders } = usePaymentMethodProviders();
  const paymentMethodProviders = state?.paymentMethodProviders;
  const { fetching, fetchCompleted, setFetching, setFetchCompleted } =
    useFetching();
  // This is not being exported anywhere. It's just being used to stop this: https://flocknote.monday.com/boards/4103834487/views/92944097/pulses/7666266145
  const [error, setError] = useState();

  const getPaymentMethods = useCallback(async () => {
    if (!userID) return;
    if (fetching || fetchCompleted || error) return;
    if (paymentMethodProviders.length) return;

    setFetching(true);

    API.getSavedPaymentMethods(userID)
      .post()
      .then((resp) => {
        setPaymentMethodProviders(resp?.paymentMethodProviders);
        dispatch({
          type: "Set Payment Methods And User",
          payload: {
            paymentMethods: resp.paymentMethods.sort((method) =>
              method.isDefaultPaymentMethod ? -1 : 0
            ),
            user: resp.user,
            isCardAllowed: resp.isCardAllowed,
            isACHAllowed: resp.isACHAllowed,
          },
        });
        setFetchCompleted(true);
      })
      .catch((err) => {
        setError(err?.message || err);
        return err;
      })
      .finally(() => {
        setFetching(false);
      });
  }, [
    setPaymentMethodProviders,
    userID,
    dispatch,
    fetching,
    fetchCompleted,
    error,
    setFetching,
    setFetchCompleted,
    paymentMethodProviders.length,
  ]);

  // Fetch Payment Methods and Save to State
  useEffect(() => {
    getPaymentMethods();
  }, [getPaymentMethods]);
}
